import React from "react";
import {
  EXERCISE_TYPE_ARRAY,
  MUSCLE_GROUP_ARRAY,
  EXERCISE_TYPE,
  PRIMARY_MUSCLE_GROUP,
} from "../../constants";
import Select from "./select";

function SelectExerciseTypeMuscleGroups({ value, handleChange, type, form }) {
  const name =
    type === EXERCISE_TYPE
      ? "exerciseTypeField"
      : type === PRIMARY_MUSCLE_GROUP
      ? "primaryMuscleGroup"
      : "secondaryMuscleGroup";
  return (
    <Select
      name={name}
      value={value}
      onChange={(newVal) => handleChange({ target: { name, value: newVal } })}
      options={(type === EXERCISE_TYPE
        ? EXERCISE_TYPE_ARRAY
        : MUSCLE_GROUP_ARRAY
      ).map((elem) => {
        return { value: elem, text: elem };
      })}
    />
  );
}

export default SelectExerciseTypeMuscleGroups;
